import { render, staticRenderFns } from "./StarredApplications.vue?vue&type=template&id=302984a8&"
import script from "./StarredApplications.vue?vue&type=script&lang=js&"
export * from "./StarredApplications.vue?vue&type=script&lang=js&"
import style0 from "./StarredApplications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports